























import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';

import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';

import { Product, WaterMonitorsApi } from '@/api';

import { ApiUtils, FilterParam } from '@/common/ApiUtils';
import { DataTableState, TableContext } from '@/typings/datatable.ts';

@Component({
	components: {
		secondaryNav,
		DataTableWithFilters,
	},
})
export default class MonitorList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			{ key: 'name', sortable: true },
			{ key: 'product.name', sortable: true, label: 'Product' },
			{ key: 'status', sortable: true },
		],
		loading: false,
		search: null,
		sortBy: 'id',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [
		{
			label: 'Status',
			field: 'status',
			value: 'sign-off',
			type: 'checkboxes',
			options: [
				{ text: 'Cancelled', value: 'cancelled' },
				{ text: 'Install', value: 'install' },
				{ text: 'Live', value: 'live' },
				{ text: 'Pending', value: 'pending' },
				{ text: 'Removed', value: 'removed' },
				{ text: 'Sign Off', value: 'sign-off' },
			],
		},
	];

	private waterMonitorsApi: WaterMonitorsApi;

	constructor() {
		super();
		this.waterMonitorsApi = new WaterMonitorsApi();
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'products-datatable');
	}

	public clickTable(item: Product, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'products.water.entity.view',
				params: { productId: item.product.id, entityType: 'water_monitors', entityId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: 'products.water.entity.view',
				params: { productId: item.product.id, entityType: 'water_monitors', entityId: item.id },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];
		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				return { field: filter.field, value: filter.value };
			});
			if (this.state.search) {
				// filters.push({field: 'supplierNumber', value: this.state.search});
				filters.push({ field: 'custom', value: this.state.search });
			}

			// filters.push({ field: 'status', value: 'sign-off' }); // fuel

			const response = await this.waterMonitorsApi.getWaterMonitors(
				ApiUtils.queryOptions(filters, ctx, { params: { include: 'product,site' } }),
			);
			data = response.data.data;
			this.state.totalRows = response.data.meta.total || 0;
		} catch (e) {
			this.state.totalRows = 0;
		}
		return data;
	}
}
